import React from 'react';

import SignInLink from '@components/authorization/signInLink';
import { OnboardingContainer } from '@components/layout/onboardingContainer';
import TermsAndPrivacyLinks from '@components/_shared/termsAndPrivacyLinks';
import { SignUpButtons } from '@components/authorization/signUpButtons';
import { BackButton } from '@components/_shared/backButton';
import { BaseComponentProps } from '@utils/types/baseComponents';
import {
  SegmentEventNamesEnum,
  SegmentEventPagesEnum,
  useAnalytics,
} from '@utils/hooks/useAnalytics';

import styles from './styles.module.scss';

type Props = {
  onBackClick: () => void;
  onGoogleSignUpClick: () => void;
  onSignUpWithEmailClick: () => void;
  onSignInClick: () => void;
} & BaseComponentProps;

export function SignUpForm(props: Props) {
  const {
    containerStyle,
    onBackClick,
    onGoogleSignUpClick,
    onSignUpWithEmailClick,
    onSignInClick,
  } = props;
  const { trackEvent } = useAnalytics();

  const onGoogleClick = () => {
    trackEvent(SegmentEventNamesEnum.CONTINUE_WITH_GOOGLE_CLICK, {
      PageName: SegmentEventPagesEnum.HOME_PAGE,
    });
    onGoogleSignUpClick();
  };

  const onSignUp = () => {
    trackEvent(SegmentEventNamesEnum.SIGNUP_CLICK, {
      PageName: SegmentEventPagesEnum.HOME_PAGE,
    });
    onSignUpWithEmailClick();
  };

  const onLogin = () => {
    trackEvent(SegmentEventNamesEnum.LOGIN_BUTTON_CLICK, {
      PageName: SegmentEventPagesEnum.HOME_PAGE,
    });
    onSignInClick();
  };

  return (
    <OnboardingContainer containerStyle={containerStyle}>
      <BackButton containerStyle={styles.backButton} onClick={onBackClick} />

      <div className={styles.formContainer}>
        <h1 className={styles.title}>Sign up</h1>

        <div className={styles.subtitle}>
          We&apos;re excited for you to join us.
        </div>

        <SignUpButtons
          onGoogleSignUpClick={onGoogleClick}
          onSignUpWithEmailClick={onSignUp}
        />

        <TermsAndPrivacyLinks />

        <SignInLink
          onSignInClick={onLogin}
          containerStyle={styles.signInLink}
        />
      </div>
    </OnboardingContainer>
  );
}
